module.exports = __webpack_public_path__ + "static/best3-b7e8df4fd1357bf9a54845e010a5efa4.jpg";